import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SecurityContext, ViewChild, ViewEncapsulation } from '@angular/core';
import { find } from 'lodash';
import { KeyboardKeyCodes } from 'common/common/constants/keyboard-key-codes';
import * as emailAddressHelper from 'email-addresses';
import { slashCommands } from 'common/common/constants/slash-commands';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { broadcastEvents } from 'common/common/constants/broadcast-events';
import { Attachments } from 'shared/components/attachments/attachments';
import { AttachmentError } from 'shared/components/email-attachments/attachment-error';
import { EditorMessages } from 'shared/components/editor-messages/editor-messages';
import { WrapupPanelService } from '../../shared/components/wrapup-panel/wrapup-panel.service';
import { WorkItemStateHandler } from 'shared/services/workitem-state-handler/workitem-state-handler.service';
import { CannedMessageRequest } from 'common/canned-messages/canned-message-request.interface';
import Moment from 'moment';
import { Attachment } from 'shared/components/attachments/attachment.model';
import { WrapUp } from 'common/api/models/wrap-up.model';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { CoolSessionStorage } from '@angular-cool/storage';
import { LinkTargetBlankFilter } from 'common/html-helper/link-target-blank';
import { BcAnalytics } from 'common/analytics/analytics.service';
import { WorkAreaManager } from 'common/workitems/work-area-manager.service';
import { TranslateService } from '@ngx-translate/core';
import { BcConfigService } from 'common/config/provider';
import { DomSanitizer } from '@angular/platform-browser';
import { FileUploadService } from 'common/api/file-upload-service';
import { WorkItemLaneType } from 'shared/components/lane-buttons/shared/services/lane-manager/work-item-lane-type.enum';
import { LaneManagerService } from 'shared/components/lane-buttons/shared/services/lane-manager/lane-manager.service';
import { DiscussionsService } from 'shared/components/discussions/discussions.service';
import { BcFeatures } from 'common/common/constants/feature-enums';
import { Settings } from 'common/settings/settings.interface';
import { EmailSignatureInjectorService } from '../../shared/services/email-signature-injector.service';
import { EmailAccountsService } from '../../shared/services/email-accounts.service';
import { EmailType } from 'common/emails/email-types';
import { ClosingConfirmationService } from 'shared/components/confirmation-modal/confirmation-modal.service';
import { ConfirmationModalComponent } from 'shared/components/confirmation-modal/confirmation-modal.component';
import { EmailMoreActionsComponent } from 'shared/components/work-widget-control-panel/email-more-actions/email-more-actions.component';
import { EmailControlPanelComponent } from 'shared/components/work-widget-control-panel/email-control-panel/email-control-panel.component';
import { ConfirmationModalConfig } from 'shared/components/confirmation-modal/confirmation-modal-config';
import { BcSettingsService } from 'common/settings/settings.service';
import { AttachmentStorageService } from 'common/attachment-storage-service/attachment-storage.service';
import { EmailsService } from 'common/emails/emails.service';
import { InnerHtmlPipe } from 'shared/components/canned-message-panel/filters/inner-html.pipe';

@Component({
  selector: 'app-email-box',
  templateUrl: './email-box.component.html',
  styleUrls: ['./email-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailBoxComponent implements OnInit, OnDestroy {
  @Input()
  emailThread;

  @Input()
  lastEmail;

  @Input()
  workItemId: string;

  @Input()
  workItemType: string;

  @Input()
  isCannedMessagePanelOpen: boolean;

  @Input()
  cannedMessageRequest: CannedMessageRequest;

  @Output()
  updateEmail: EventEmitter<void> = new EventEmitter();

  @ViewChild('sendAndCloseConfirmationModal')
  sendAndCloseConfirmationModal: ConfirmationModalComponent;

  @ViewChild('closeConfirmationModal')
  closeConfirmationModal: ConfirmationModalComponent;

  @ViewChild(EmailMoreActionsComponent)
  emailMoreActionsComponent: EmailMoreActionsComponent;

  @ViewChild(EmailControlPanelComponent)
  emailControlPanelComponent: EmailControlPanelComponent;

  public sendAndCloseConfirmationBoxConfig: ConfirmationModalConfig = {
    title: 'bcEmailBox.sendAndCloseEmailConfirmationTitle',
    buttonTitle: 'bcEmailBox.confirmationBox.yes',
    secondaryActionTitle: 'bcEmailBox.confirmationBox.dontShowAgain',
    cancelTitle: 'bcEmailBox.confirmationBox.continue'
  };

  public closeConfirmationBoxConfig: ConfirmationModalConfig = {
    title: 'bcEmailBox.closeEmailConfirmationTitle',
    buttonTitle: 'bcEmailBox.confirmationBox.yes',
    secondaryActionTitle: 'bcEmailBox.confirmationBox.dontShowAgain',
    cancelTitle: 'bcEmailBox.confirmationBox.continue'
  };

  public linkTargetBlankFilter;
  public editorMessages;
  public footerModes;
  public attachments;
  public setFocusOnEditorSubscription;
  public keyDownEventListener;
  public editorCommandList;
  public modes;
  public compose;
  public isSelectMenuOpened;
  public isTransferPanelActive;
  public sendingInProgress;
  public isMoreActionsVisible;
  public senderEmailAccount;
  public editorInstance;

  public outgoingHeaderCancelFooter;
  public sendButtonErrorMessage;

  public moment;
  public editorInitSetting;

  public sendAndCloseConfirmationVisible: boolean = false;
  public closeConfirmationVisible: boolean = false;

  public wrapups: WrapUp[][] = [];
  public areWrapupsLoaded = false;
  public footer;
  public isQuotedMessageAdded;

  private static readonly InnerHtmlPipe = new InnerHtmlPipe();

  private _workItemLanes;
  private _laneObservable;
  private _hasDiscussion;

  constructor(private _xlcEmails: EmailsService, private FileUploadService: FileUploadService,
              private _bcConfig: BcConfigService, private _bcAnalytics: BcAnalytics,
              private _bcSettingsService: BcSettingsService, private _workAreaManager: WorkAreaManager,
              private _emailAccountsService: EmailAccountsService, private _element: ElementRef,
              private _attachmentStorageService: AttachmentStorageService, private _sanitizer: DomSanitizer,
              private _emailSignatureInjectorService: EmailSignatureInjectorService,
              private _closingConfirmationService: ClosingConfirmationService,
              private _wrapupPanelService: WrapupPanelService, private _workItemStateHandler: WorkItemStateHandler,
              private _rxEmitter: RxEmitter, private _translateService: TranslateService,
              private _coolSessionStorage: CoolSessionStorage, private _changeDetector: ChangeDetectorRef,
              private _laneManager: LaneManagerService, private _discussionsService: DiscussionsService) {

    this.linkTargetBlankFilter = LinkTargetBlankFilter();
    this.editorMessages = new EditorMessages();
    this.moment = Moment;

    this.footerModes = {
      EDITOR: 1,
      HEADER: 2,
      CONTROL_PANEL: 3,
      WRAPUP: 4
    };

    this.modes = {
      REPLY: 0,
      REPLYALL: 1,
      FORWARD: 2
    };

    this.outgoingHeaderCancelFooter = {
      mode: -1
    };

    this.initCommandList();

    this.editorInitSetting = {
      toolbar: 'bold italic underline strikethrough link bullist numlist outdent indent undo redo insertImage'
    };
  }

  ngOnInit(): void {
    this.resetState();
    this._loadWrapups();
    this.attachments = new Attachments(
      this._bcSettingsService,
      this._bcAnalytics,
      this.editorMessages,
      this.FileUploadService,
      this._bcConfig,
      this._xlcEmails,
      this._attachmentStorageService.createOrGetStorage(this.workItemId)
    );
    this.setFocusOnEditorSubscription = this._rxEmitter.subscribe(`${MessageBusEvents.SetDefaultFocusInLane}${this.workItemId}`, () => {
      this.setFocusOnEditor();
    });

    this.keyDownEventListener = (e) => this.handleKeyDown(e);
    this._element.nativeElement.addEventListener('keydown', this.keyDownEventListener);
    this.initLaneObservable();
    this.loadDiscussionSetting();
  }

  ngOnDestroy(): void {
    if (this._laneObservable) {
      this._laneObservable.unsubscribe();
      this._laneObservable = null;
    }
    if (this.setFocusOnEditorSubscription) {
      this.setFocusOnEditorSubscription.unsubscribe();
      this.setFocusOnEditorSubscription = null;
    }
    this._attachmentStorageService.deleteStorage(this.workItemId);
    this._element.nativeElement.removeEventListener('keydown', this.keyDownEventListener);
  }

  onEditorSetupDone(editor): void {
    this.editorInstance = editor;

    if (this.isFocused()) {
      this.setFocusOnEditor();
    }

    this.editorInstance.settings.placeholder = this._translateService.instant('bcEmailBox.form.messagePlaceholder');
  }

  setFocusOnEditor(): void {
    if (this.editorInstance) {
      if (this.editorInstance.initialized) {
        this._rxEmitter.send(broadcastEvents.focusEditor, null);
      } else {
        this.editorInstance.on('init', () => {
          this._rxEmitter.send(broadcastEvents.focusEditor, null);
        });
      }
    } else {
      this._element.nativeElement.focus();
    }
  }

  isFocused(): boolean {
    return this._workItemStateHandler.isFocused(this.workItemId);
  }

  initCommandList(): void {
    this.editorCommandList = [
      { shortcut: slashCommands.CANNED_MESSAGES, description: 'bcEmailBox.commands.cannedMessage' },
      { shortcut: slashCommands.CLOSE_EMAIL, description: 'bcEmailBox.commands.closeEmail' },
      { shortcut: slashCommands.ASSIGN, description: 'bcEmailBox.commands.reassign' }
    ];
  }

  hasWrapUps(): boolean {
    return !!this.wrapups;
  }

  initLaneObservable(): void {
    this._laneObservable = this._laneManager.getLaneObservable(this.workItemId)
      .subscribe(lanes => {
        this._workItemLanes = lanes;
      });
  }

  async loadDiscussionSetting(): Promise<void> {
    const settings: Settings = await this._bcSettingsService.getSettings();
    this._hasDiscussion = this._bcSettingsService.ChatFeatures.isEnabled(settings, BcFeatures.LC_DISCUSSIONS);
    this._changeDetector.detectChanges();
  }

  resetState(): void {
    this._setFooterMode(this.footerModes.CONTROL_PANEL);

    this.compose = {
      from: {},
      to: '',
      cc: '',
      bcc: '',
      subject: '',
      message: '',
      mode: -1
    };

    this._changeDetector.detectChanges();

    this.editorMessages.clearAllMessages();
    this.isSelectMenuOpened = false;
    this.isTransferPanelActive = false;
    this.sendingInProgress = null;
    this.isMoreActionsVisible = false;
    this.isQuotedMessageAdded = false;

    this._setFrom();
  }

  _setFrom(): void {
    this._emailAccountsService.getEmailAccounts().then(accountList => {
      if (!accountList) {
        const noSenderEmailAddressErrorMessage = 'bcEmailBox.noSenderEmailAddress';
        this.editorMessages.addEditorMessage('noSenderEmailAddress', noSenderEmailAddressErrorMessage);
        return;
      } else {
        let accountOptions;
        let accountInStorage = this._getDraftFromStorage(this.emailThread.id);
        if (accountInStorage && accountInStorage.selectedFromAccount && accountInStorage.selectedFromAccount.selected) {
          accountOptions = accountList.map((account) => {
            return {
              label: account.fromEmail,
              value: account.id,
              selected: account.id === accountInStorage.selectedFromAccount.value
            };
          });
          this.senderEmailAccount = accountOptions.find(account => account.value === accountInStorage.selectedFromAccount.value);
          this.compose.from.items = accountOptions;
        } else {
          accountOptions = accountList.map((account) => {
            return {
              label: account.fromEmail,
              value: account.id,
              selected: account.id === this.emailThread.senderEmailAccountId
            };
          });
          for (let i = 0; i < accountOptions.length; i++) {
            if (accountOptions[i].value === this.emailThread.senderEmailAccountId) {
              this.senderEmailAccount = accountOptions[i];
              break;
            }
          }
          if (!this.senderEmailAccount) {
            this.senderEmailAccount = accountOptions[0];
            this.compose.from.items = accountOptions;
            this.compose.from.items[0].selected = true;
          } else {
            this.compose.from.items = accountOptions;
            this.compose.selectedFromAccount = this.senderEmailAccount;
          }
        }
      }

      this.editorMessages.removeEditorMessage('noSenderEmailAddress');
    });
  }

  handleKeyDown(event): void {
    if (event.which === KeyboardKeyCodes.ESC) {
      event.preventDefault();
      event.stopPropagation();

      this._closeCannedMessagePanel();
      this._closeTransferPanel();

      if (this.isFooterModeActive(this.footerModes.WRAPUP)) {
        this.toggleWrapupPanel();
      }

      this._changeDetector.detectChanges();
      this.setFocusOnEditor();
    }
  }

  getEmailBody(email): string {
    if (email.html) {
      return this._sanitizer.sanitize(SecurityContext.HTML, this.linkTargetBlankFilter(email.html));
    }

    return email.body;
  }

  private _getEmailHeadersInSafeFormat(email) {
    return {
      senderInfo: this._buildTextWithCharacterEntities(email.fromFullEmailAddress),
      receiverInfo: this._buildTextWithCharacterEntities(email.toFullEmailAddresses),
      subject: this._buildTextWithCharacterEntities(email.subject),
      sentDate: this.moment(email.sentDate).format('LLL')
    };
  }

  private _buildTextWithCharacterEntities(address: string): string {
    return address.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  clearEditorMessage(): void {
    this.editorMessages.clearAllMessages();
    this.sendingInProgress = null;
  }

  editorChange(event): void {
    // Insert target="_blank" attribute on links
    if (this.editorInstance && this.editorInstance.attributeIsActive('href')) {
      const tempNode = document.createElement('div');
      tempNode.innerHTML = event.target.innerHTML;

      const linkNode = tempNode.querySelector('a[href]');
      linkNode.setAttribute('target', '_blank');

      // Insert modified anchor tag
      event.target.innerHTML = '<div>' + (<any>linkNode.parentNode).innerHTML + '</div>';
    }
  }

  addQuotedContent(): void {
    this.isQuotedMessageAdded = true;
    this.compose.message = this._addOriginalEmailMessageForMessage(this.compose.message, this.getEmailBody(this.lastEmail));
  }

  public showSendAndCloseConfirmation(): void {
    this.sendAndCloseConfirmationVisible = true;
  }

  public hideSendAndCloseConfirmation(): void {
    this.sendAndCloseConfirmationVisible = false;
  }

  public showCloseEmailThreadConfirmation(): void {
    this.closeConfirmationVisible = true;
  }

  public hideCloseEmailConfirmation(): void {
    this.closeConfirmationVisible = false;
  }

  public isConfirmationModalDisabled(): boolean {
    return <boolean>(this._closingConfirmationService.getClosingConfirmationSetting(this.workItemType));
  }

  public closeEmailThreadAndDontShowModal(): void {
    this._closingConfirmationService.setClosingConfirmation(this.workItemType, true);
    this._rxEmitter.send(MessageBusEvents.ShowConfirmationPanelTooltip, null);
    this.closeEmailThread();
  }

  public sendAndCloseAndDontShowModal(): void {
    this._closingConfirmationService.setClosingConfirmation(this.workItemType, true);
    this._rxEmitter.send(MessageBusEvents.ShowConfirmationPanelTooltip, null);
    this.sendAndClose();
  }

  public closeEmailThreadOrShowConfirmation(): void {
    if (this.isConfirmationModalDisabled()) {
      this.closeEmailThread();
    } else {
      this.showCloseEmailThreadConfirmation();
    }
  }

  public sendAndCloseEmailOrShowConfirmation(): void {
    if (this.isConfirmationModalDisabled()) {
      this.sendAndClose();
    } else {
      this.showSendAndCloseConfirmation();
    }
  }

  async pressReply(): Promise<void> {
    this.compose.to = this.lastEmail.replyToAddresses || this.lastEmail.fromFullEmailAddress; // RFC2822 3.6.2. Originator fields
    this.compose.cc = '';
    this.compose.bcc = '';
    this.compose.subject = EmailBoxComponent.buildSubjectForSend(this.lastEmail.subject, 'RE');
    this.compose.mode = this.modes.REPLY;
    this._setFooterMode(this.footerModes.EDITOR);
    this._bcAnalytics.eventTrack('EmailButton', { button: 'Reply' });
    this.setFocusOnEditor();

    if (this.isOutboundEmail(this.lastEmail)) {
      this.editorMessages.addEditorMessage('replyToOutboundEmail', 'bcEmailBox.replyToOutboundEmail');
      this.openOutgoingHeaderPanel();
    }

    await this._addSignatureOfAccount();
  }

  async pressReplyAll(): Promise<void> {
    this.compose.to = (this.lastEmail.replyToAddresses || this.lastEmail.fromFullEmailAddress) + '; ' + this.lastEmail.toFullEmailAddresses; // RFC2822 3.6.2. Originator fields
    this.compose.cc = this.lastEmail.ccFullEmailAddresses;
    this.compose.bcc = '';
    this.compose.subject = EmailBoxComponent.buildSubjectForSend(this.lastEmail.subject, 'RE');
    this.compose.mode = this.modes.REPLYALL;
    this.outgoingHeaderCancelFooter.mode = this.footerModes.CONTROL_PANEL;
    this._setFooterMode(this.footerModes.HEADER);
    this._bcAnalytics.eventTrack('EmailButton', { button: 'ReplyAll' });
    this.setFocusOnEditor();

    await this._addSignatureOfAccount();
  }

  onReplyCancel(): void {
    this.resetState();
    this._attachmentStorageService.clearStorage(this.workItemId);
    this._bcAnalytics.eventTrack('EmailButton', { button: 'ReplyCancel' });
  }

  pressDiscuss(): void {
    this._openDiscussionLane();
    this._bcAnalytics.eventTrack('EmailButton', { button: 'Discussion', from: 'ControlPanel' });
  }

  openDiscussions(): void {
    this._openDiscussionLane();
    this._bcAnalytics.eventTrack('EmailButton', { button: 'Discussion', from: 'Reply' });
  }

  private _openDiscussionLane(): void {
    this._laneManager.openLane(this.workItemId, WorkItemLaneType.Discussions.toString(), this.workItemType);
  }

  get canStartDiscussion() {
    return this._hasDiscussion && this._discussionsService.hasDiscussionPermission(this.workItemType) && this._discussionsService.isDiscussionsEnabled();
  }

  get isDiscussionsLaneVisible(): boolean {
    return this._isLaneVisible(WorkItemLaneType.Discussions);
  }

  private _isLaneVisible(laneType: WorkItemLaneType): boolean {
    // Lane visibility togglers used only in expanded mode
    if (!this.isExpandedMode()) {
      return true;
    }

    const lane = this._workItemLanes && this._workItemLanes.find(workItemLane => workItemLane.type === laneType);
    return lane && lane.visible;
  }

  _cleanRecipientList(composed): void {
    this.compose.to = this.filterEmailFromEmailList(this.senderEmailAccount.label, composed.to);
    this.compose.cc = this.filterEmailFromEmailList(this.senderEmailAccount.label, composed.cc);
  }

  /**
   * This function returns a normalized list of e-mails. The list does not contain the e-mail address, which was used
   * as filter.
   *
   * The following normalizations were applied on the elements of the list:
   *  * if the e-mail has a "name" in it, it will be always added to the new list in the format:
   *    "Name name" <email@address.com>
   *  * if the e-mail does not have name, it will just added as a simple e-mail address
   *
   * @param filteredEmail The e-mail address, which is used as a filter.
   * @param emailList The original e-mail list
   * @returns {String} the list of e-mail addresses (without the filteredEmail) separated by ";" .
   *  If the filter was invalid, it returns the original, unmodified e-mail list.
   */
  filterEmailFromEmailList(filteredEmail: string, emailList: string): string {
    if (!filteredEmail || !emailList) {
      return emailList;
    }

    const filterEmailAddress = emailAddressHelper.parseOneAddress(filteredEmail) as emailAddressHelper.ParsedMailbox;
    const emailListParsed = emailList.split(';');
    const toBeReturnedArray = [];

    emailListParsed.forEach((emailListItem) => {
      const emailProcessed = emailAddressHelper.parseOneAddress(emailListItem) as emailAddressHelper.ParsedMailbox;
      if (emailProcessed && emailProcessed.address !== filterEmailAddress.address) {
        let toBePushed = null;
        if (!emailProcessed.name) {
          toBePushed = emailProcessed.address;
        } else {
          toBePushed = `"${emailProcessed.name}" <${emailProcessed.address}>`;
        }

        toBeReturnedArray.push(toBePushed);
      }
    });
    return toBeReturnedArray.join('; ');
  }

  async pressForward(): Promise<void> {
    this.compose.to = '';
    this.compose.cc = '';
    this.compose.bcc = '';
    this.compose.subject = EmailBoxComponent.buildSubjectForSend(this.lastEmail.subject, 'FW');
    this.compose.mode = this.modes.FORWARD;
    this.outgoingHeaderCancelFooter.mode = this.footerModes.CONTROL_PANEL;
    this._setFooterMode(this.footerModes.HEADER);
    this._bcAnalytics.eventTrack('EmailButton', { button: 'Forward' });

    await this._addSignatureOfAccount();
  }

  private _addAttachmentsFromLastEmail(): void {
    if (this.lastEmail.attachments) {
      this.lastEmail.attachments.forEach((attachment: Attachment) => {
        const copiedAttachment = { ...attachment, canDelete: true };
        this.attachments.addAttachment(copiedAttachment);
      });
    }
  }

  public static buildSubjectForSend(subject: string, prefix: string): string {
    if (prefix !== 'RE' && prefix !== 'FW') {
      throw new Error('Invalid prefix, only "RE" and "FW" are supported!');
    }

    const existingPrefix = subject.substr(0, 4);
    const remainingSubject = subject.substr(4);
    switch (existingPrefix) {
      case 'RE: ':
        return prefix === 'FW' ? `FW: ${remainingSubject}` : subject;
      case 'FW: ':
        return prefix === 'RE' ? `RE: ${remainingSubject}` : subject;
      default:
        return `${prefix}: ${subject}`;
    }
  }

  private _assembleComposedMessage(composedMessage: string, originalEmailMessage: string): string {
    return this.isQuotedMessageAdded
      ? composedMessage
      : this._addOriginalEmailMessageForMessage(composedMessage, originalEmailMessage);
  }

  private _addOriginalEmailMessageForMessage(composedMessage: string, originalEmailMessage: string): string {
    const emailInfo = this._getEmailHeadersInSafeFormat(this.lastEmail);

    return `${composedMessage}<br />
            <br />
            ----- Original Message -----<br />
            From: ${emailInfo.senderInfo}<br />
            Date: ${emailInfo.sentDate}<br />
            To: ${emailInfo.receiverInfo}<br />
            Subject: ${emailInfo.subject}<br />
            <br />
            ${originalEmailMessage}`;
  }

  public sendAndClose(): Promise<void> {
    this.hideSendAndCloseConfirmation();
    this._bcAnalytics.eventTrack('EmailButton', { button: 'SendAndClose' });
    return this._sendEmailMessage().then(() => {
      return this.closeEmailThread();
    }).catch(err => {
      throw new Error('Email sending failed: ' + err);
    });
  }

  public sendEmailMessageClick(): Promise<void> {
    this._bcAnalytics.eventTrack('EmailButton', { button: 'Send' });
    return this._sendEmailMessage();
  }

  private _sendEmailMessage(): Promise<void> {
    if (this.isSendingInProgress()) {
      return this.sendingInProgress;
    }

    return this._createAndSendEmailMessage();
  }

  private _createAndSendEmailMessage(): Promise<void> {
    this.editorMessages.clearAllMessages();
    this.editorMessages.addEditorMessage('sending', 'bcEmailBox.sendingEmail');
    const msg = this._assembleComposedMessage(this.compose.message, this.getEmailBody(this.lastEmail));
    const emailDetails = {
      senderEmailAccountId: this.senderEmailAccount.value,
      to: this.compose.to,
      cc: this.compose.cc,
      bcc: this.compose.bcc,
      subject: this.compose.subject,
      message: msg
    };
    if (this.attachments.isEmpty()) {
      this.sendingInProgress = this._sendingEmailToThread(emailDetails, undefined);
    } else {
      this.sendingInProgress = this.attachments.validateAttachmentsAvailability()
        .then(() => this.attachments.uploadAttachments(this.emailThread.id))
        .then((response) => {
          const attachments = response && response.data ? response.data : null;
          return this._sendingEmailToThread(emailDetails, attachments);
        })
        .catch((err) => {
          if (err instanceof AttachmentError) {
            this.editorMessages.removeEditorMessage('sending');
            this.editorMessages.addEditorMessage('invalidAttachment', 'bcEmailBox.invalidAttachment');
            this._changeDetector.detectChanges();
          } else {
            this.editorMessages.removeEditorMessage('sending');
            this.editorMessages.addEditorMessage('sendingError', this._getTranslateCodeForStatusCodeType(err.status));
            this.sendingInProgress = null;
            throw err;
          }
        });
    }

    return this.sendingInProgress;
  }

  private _sendingEmailToThread(emailDetails, attachments): Promise<void> {
    return this._xlcEmails.sendEmailToThread(this.emailThread.id, this.lastEmail.id, emailDetails, attachments)
      .then(() => {
        this.resetState();
        this._attachmentStorageService.clearStorage(this.workItemId);
      })
      .then(() => this.updateEmail.emit())
      .catch(err => {
        this.editorMessages.removeEditorMessage('sending');
        this.editorMessages.addEditorMessage('sendingError', this._getTranslateCodeForStatusCodeType(err.status));
        this.sendingInProgress = null;
        this._emailAccountsService.reloadEmailAccounts();
        this._setFrom();
        throw err;
      });
  }

  public isSendingInProgress(): boolean {
    return !!this.sendingInProgress;
  }

  public isEmailThreadActive(): boolean {
    return this.emailThread && !this.emailThread.closed;
  }

  public hasValidEmailHeader(): boolean {
    if (this.compose.to === '' && this.compose.cc === '' && this.compose.bcc === '') {
      this.sendButtonErrorMessage = 'bcEmailBox.noValidEmailAddress';
      this.editorMessages.addEditorMessage('noValidEmailAdress', this.sendButtonErrorMessage);

      return false;
    }

    this.editorMessages.removeEditorMessage('noValidEmailAdress');
    return true;
  }

  private _getTranslateCodeForStatusCodeType(statusCode: number): string {
    let statusMessage;

    if (statusCode === 413) {
      statusMessage = 'bcEmailBox.oversizedAttachmentError';
    } else {
      statusMessage = 'bcEmailBox.sendingEmailError';
    }

    return statusMessage;
  }

  async closeEmailThread(): Promise<void> {
    this.hideCloseEmailConfirmation();
    await this._xlcEmails.closeEmailThread(this.emailThread.id);
    this.emailThread.closed = true;
    this.updateEmail.emit();
    this._bcAnalytics.eventTrack('EmailThreadClosed');
  }

  public openOutgoingHeaderPanel(): void {
    this.outgoingHeaderCancelFooter.mode = this.footerModes.EDITOR;
    this._setFooterMode(this.footerModes.HEADER);
  }

  // region Footer pane.

  /**
   * Sets the currently visible pane in the footer.
   * @param {number} footerMode - The desired panel to show in the footer. See the this.footerModes enum for the available values.
   * @throws {Error} If the specified footerMode does not exist.
   */
  private _setFooterMode(footerMode: number): void {
    this._validateFooterMode(footerMode);
    this.footer = { mode: footerMode };
  }

  /**
   * Returns whether the specified pane is currently visible in the footer.
   * @param {number} footerMode - The panel to check in the footer. See the this.footerModes enum for the available values.
   * @throws {Error} If the specified footerMode does not exist.
   * @returns {boolean}
   */
  public isFooterModeActive(footerMode: number): boolean {
    this._validateFooterMode(footerMode);
    return this.footer.mode === footerMode;
  }

  /**
   * Checks whether the specified value is a valid footer mode.
   * @param {number} footerMode - The value to verify. See the this.footerModes enum for the valid values.
   * @throws {Error} If the specified footerMode does not exist.
   * @private
   */
  private _validateFooterMode(footerMode: number): void {
    const modeFound = find(this.footerModes, mode => mode === footerMode);
    if (!modeFound) {
      throw new Error('The specified footer mode does not exist!');
    }
  }

  // endregion

  // region Event handlers for the Subject and Recipients panel.

  /**
   * Event handler that is called when the user clicks the "Continue with the message" button in the "Subject and Recipients" panel.
   */
  public async onHeaderSave(newModel): Promise<void> {
    this.compose = newModel;
    this.compose.selectedFromAccount = this.compose.from.items.find(account => account.selected);
    this._setFooterMode(this.footerModes.EDITOR);
    if (this._hasEmailForwardingJustStarted()) {
      this._addAttachmentsFromLastEmail();
    }
    await this._addSignatureOfAccount();
    this.setFocusOnEditor();
  }

  /**
   * Event handler that is called when the user clicks the "Cancel" button in the "Subject and Recipients" panel.
   */
  public onHeaderCancel(oldModel): void {
    this.compose = oldModel;
    this._setFooterMode(this.outgoingHeaderCancelFooter.mode);
    this._changeDetector.detectChanges();
    this.setFocusOnEditor();
  }

  // endregion

  private _hasEmailForwardingJustStarted(): boolean {
    return this.compose.mode === this.modes.FORWARD && this.outgoingHeaderCancelFooter.mode === this.footerModes.CONTROL_PANEL;
  }

  private _closeTransferPanel(): void {
    if (this.isTransferPanelActive) {
      this.isTransferPanelActive = false;
      this._bcAnalytics.eventTrack('EmailTransferPanel', { action: bcEnums.panelAction.CLOSE });
    }
  }

  private _openTransferPanel(): void {
    if (!this.isTransferPanelActive) {
      this.isTransferPanelActive = true;
      this._bcAnalytics.eventTrack('EmailTransferPanel', { action: bcEnums.panelAction.OPEN });
    }
  }

  public toggleTransferPanel(): void {
    if (!this.isTransferPanelActive) {
      this._openTransferPanel();
    } else {
      this._closeTransferPanel();
    }
  }

  public toggleWrapupPanel(): void {
    if (this.isFooterModeActive(this.footerModes.WRAPUP)) {
      if (typeof this.outgoingHeaderCancelFooter.mode === 'undefined') {
        this._setFooterMode(this.footerModes.CONTROL_PANEL);
      } else {
        this._setFooterMode(this.outgoingHeaderCancelFooter.mode);
      }
    } else {
      this.outgoingHeaderCancelFooter.mode = this.footer.mode;
      this._setFooterMode(this.footerModes.WRAPUP);
      this.setFocusOnEditor();
    }

    this._bcAnalytics.eventTrack('EmailWrapupPanel', { action: this.isFooterModeActive(this.footerModes.WRAPUP) ? bcEnums.panelAction.OPEN : bcEnums.panelAction.CLOSE });
  }

  public executeCommand(command): void {
    this._bcAnalytics.eventTrack('SlashCommand', { type: 'email', command });
    switch (command) {
      case slashCommands.CANNED_MESSAGES:
        this._openCannedMessagePanel();
        break;
      case slashCommands.CLOSE_EMAIL:
        this.closeEmailThread();
        break;
      case slashCommands.ASSIGN:
        this.toggleTransferPanel();
        break;
      case slashCommands.WRAP_UP:
        if (this.wrapups) {
          this.toggleWrapupPanel();
        } else {
          this.editorMessages.addEditorMessage('invalidCommand', 'bcEmailBox.invalidCommand', { command: command });
        }
        break;
      default:
        this._bcAnalytics.eventTrack('InvalidCommand', { type: 'email', command });
        this.editorMessages.addEditorMessage('invalidCommand', 'bcEmailBox.invalidCommand', { command: command });
    }
    this._clearEditor();
  }

  private _clearEditor(): void {
    this.compose.message = '';
  }

  get editorMessage(): string {
    if (!this.editorInstance) {
      return '';
    }

    return this.editorInstance.getDocument().toString();
  }

  public toggleMoreActions(): void {
    this.isMoreActionsVisible = !this.isMoreActionsVisible;
  }

  public toggleCannedMessagePanel(): void {
    if (this.isCannedMessagePanelOpen) {
      this._closeCannedMessagePanel();
    } else {
      this._openCannedMessagePanel();
    }
  }

  private _openCannedMessagePanel(): void {
    this._rxEmitter.send(`${MessageBusEvents.ActivateCannedMessagePanel}${this.workItemId}`, null);
  }

  private _closeCannedMessagePanel(): void {
    this._rxEmitter.send(`${MessageBusEvents.CloseCannedMessagePanel}${this.workItemId}`, null);
  }

  public isExpandedMode(): boolean {
    return this._workAreaManager.isExpandedMode();
  }

  public changeSenderEmailAccount(selectedItem): void {
    this.senderEmailAccount = selectedItem;

    this.compose.selectedFromAccount = this.senderEmailAccount;

    if (selectedItem && this.compose.mode === this.modes.REPLYALL) {
      this._cleanRecipientList(this.compose);
    }
  }

  private async _addSignatureOfAccount() {
    if (!this.senderEmailAccount) {
      return;
    }

    return this._emailSignatureInjectorService.addSignatureOfEmailAccount(this.senderEmailAccount.value).then(signature => {
      if (!signature) {
        return;
      }
      const signatureElement = this.editorInstance.dom.select('div', 'email-signature');

      const signatureTag = document.createElement('div');
      signatureTag.className = 'email-signature';
      signatureTag.innerHTML = EmailBoxComponent.InnerHtmlPipe.transform(signature);

      if (signatureElement[0]) {
        this.editorInstance.dom.replace(signatureTag, signatureElement[0]);
      } else {
        this.editorInstance.dom.add(this.editorInstance.getBody(), signatureTag);
      }

      this.compose.message = this.editorInstance.getContent();
    });
  }

  private _loadWrapups(): Promise<void> {
    return this._wrapupPanelService.getWrapUps(this.workItemType, this.workItemId)
      .then((wrapUps) => {
        this.wrapups = wrapUps;
        this.areWrapupsLoaded = true;
        if (this.wrapups) {
          this.editorCommandList.push({ shortcut: slashCommands.WRAP_UP, description: 'bcEmailBox.commands.wrapup' });
        }
      });
  }

  private _getDraftFromStorage(key) {
    const draft = this._coolSessionStorage.getItem('drafts');
    return draft ? JSON.parse(draft)['email-' + key] : null;
  }

  public isOutboundEmail(email) {
    return email && email.emailType === EmailType.OUTBOUND;
  }
}
